import { defineMessages } from 'react-intl';

const _default_1: {
	loadingMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	loadingMessage: {
		id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
		defaultMessage: 'Loading...',
		description: 'The text for when options are being loaded in dropdown',
	},
});
export default _default_1;
